import React, { Suspense } from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Login from '../Auth/Login'
import NotFound from '../layouts/error/NotFound'
import PrivateRoute from './PrivateRoute'
import ChangePassword from '../Auth/ChangePassword'
import Profile from '../Auth/Profile'
import Product from '../pages/Product'
import SettingsDetail from '../pages/settings/SettingsDetail'
import ProductDetail from '../pages/ProductDetail'
import Consts from '../pages/settings/Consts'
import ConstChild from '../pages/settings/ConstChild'
import ConstChildCreate from '../pages/settings/ConstChildCreate'
import Usercomment from '../pages/Usercomment'
import Advice from '../pages/Advice'
import Order from '../pages/order/Order'
import OrderDetail from '../pages/order/OrderDetail'
import Carousel from '../pages/Carousel'
import Roles from '../pages/Roles'

const loadingComp = <div className="k-loading-mask" style={{ zIndex: 100000 }}>
    <span className="k-loading-text">Loading</span>
    <div className="k-loading-image"></div>
    <div className="k-loading-color"></div>
</div>


export default function CoreRoutes() {
    return (
        <BrowserRouter>
            <Suspense fallback={loadingComp}>
                <Routes>
                    <Route exact path='/' element={<PrivateRoute />}>\
                        <Route path="/changePassword" exact element={<ChangePassword />} />
                        <Route path="/profile" exact element={<Profile />} />
                        <Route path="/product" exact element={<Product />} />
                        <Route path="/order" exact element={<Order />} />
                        <Route path="/order/:id" exact element={<OrderDetail />} />
                        <Route path="/product/:id" exact element={<ProductDetail />} />
                        <Route path="/settings" exact element={<SettingsDetail />} />
                        <Route path="/usercomment" exact element={<Usercomment />} />
                        <Route path="/advice" exact element={<Advice />} />
                        <Route path="/carousel" exact element={<Carousel />} />
                        <Route path="/consts" element={<Consts />} />
                        <Route path="/consts/:code" element={<ConstChild />} />
                        <Route path="/consts/:code/:id" element={<ConstChildCreate />} />
                        <Route path="/roles" element={<Roles />} />
                    </Route>
                    {/* <PrivateRoute exact path="/login-history" element={LoginHistory} /> */}
                    <Route path="/login" element={<Login />} />
                    {/* <Route path="/forgotpassword" exact element={<ForgotPassword />} />
                    <Route path="/resetPassword/:token" exact element={<ResetPassword />} /> */}
                    <Route path='*' element={<NotFound />} />
                </Routes>
            </Suspense>
        </BrowserRouter>
    )
}
